/**
 * Represents a mark associated with a criterion and an entry.
 */
class CriterionMark {
    /**
     * Constructs a new CriterionMark instance.
     * @param {Object} criterion - The criterion object.
     * @param {Object} entry - The entry object.
     */
    constructor(criterion, entry) {
        this.criterion = criterion;
        this.entry = entry;
        
        // Initialize accessible properties
        this.initializeProperties({
            'type': String,
            'marks': Number
        });
        
        // Initialize references
        this.initializeReferences({
            'criterion': this.criterion
        });
    }

    /**
     * Initializes accessible properties with specified types.
     * @param {Object} props - An object where keys are property names and values are expected types.
     */
    initializeProperties(props) {
        for (const [key, type] of Object.entries(props)) {
            if (this[key] !== undefined && typeof this[key] === type.name.toLowerCase()) {
                this[key] = this[key];
            } else {
                this[key] = null;
            }
        }
    }

    /**
     * Initializes references with specified values.
     * @param {Object} refs - An object where keys are reference names and values are the references.
     */
    initializeReferences(refs) {
        for (const [key, value] of Object.entries(refs)) {
            if (value !== undefined) {
                this[key] = value;
            } else {
                this[key] = null;
            }
        }
    }
}

export default CriterionMark;